import variables from '@/styles/variables.scss'

const scssVariables = variables
/**
 * @param scope 类名
 * @returns 返回空间名-类名
 */
export const getPrefixCls = (scope) => {
  return `${scssVariables.namespace}-${scope}`
}

export { scssVariables as variables } 